module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image20.ab7357ab.jpg";